import Vue from 'vue'
import Vuex from 'vuex'
import menuStore from './module/menuStore'

let mutations = Object.assign(menuStore.mutations)
let actions = Object.assign(menuStore.actions)
Vue.use(Vuex);
export default new Vuex.Store({
  state: {...menuStore.data},
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js